import { Badge } from '@/components/ui/Badge';
import { INVOICE_STATUS_LABELS, type InvoiceStatus } from '@/types/financials';

const TONES: Record<InvoiceStatus, 'neutral' | 'info' | 'warning' | 'success' | 'danger' | 'brass'> = {
  draft:    'neutral',
  sent:     'info',
  partial:  'warning',
  paid:     'success',
  past_due: 'danger',
  void:     'neutral',
};

export function InvoiceStatusBadge({ status }: { status: InvoiceStatus }) {
  return <Badge tone={TONES[status]}>{INVOICE_STATUS_LABELS[status]}</Badge>;
}
